<template>
  <div class="w-full flex flex-col items-center justify-center">
    <div class="w-full h-12 hidden sm:flex"></div>
    <div class="card flex flex-col bg-white rounded max-w-md w-full">
      <div class="flex flex-col w-full space-y-2">
        <button class="nxp-back-btn hidden sm:flex" @click="handleBackward">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <mask id="mask0_857_10485" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16"
              height="16">
              <rect width="16" height="16" fill="#696969" />
            </mask>
            <g mask="url(#mask0_857_10485)">
              <path
                d="M9.33362 11.7688L5.56445 7.99964L9.33362 4.23047L10.0361 4.93297L6.96945 7.99964L10.0361 11.0663L9.33362 11.7688Z"
                fill="#A9A9A9" />
            </g>
          </svg>
          Voltar
        </button>
        <span v-if="jobPositionReference" class="nxp-job-title">
          {{ jobPositionReference }}
        </span>
        <h1 class="nxp-title-form">
          Preencha seus dados
        </h1>
        <span class="nxp-subtitle-form">
          Adicione seus dados pessoais e preferências profissionais para completar seu perfil
        </span>
      </div>


      <div class="w-full flex flex-col space-y-10 mt-6">
        <SimpleBasicInfo />
        <SimpleCurriculumn :not-filled="emptyCurriculumn && reviewing" />
        <SimpleAddress />
        <SimpleFormation :not-filled="emptyFormation && reviewing" />
        <SimpleExperience :not-filled="experiencesIsEmpty && reviewing" />
        <SimpleLanguages />
        <SimpleSkill />
      </div>

      <button class="nxp-continue-btn mt-16" :style="{ background: color }" @click="handleForward">
        Confirmar candidatura
      </button>

      <vs-popup title="" :active.sync="alert">
        <div class="popup-container">
          <h2>
            Ops! Parece que você não preencheu nenhuma informação profissional.
          </h2>
          <div class="popup-container--image">
            <img src="@/assets/images/undraw_fitting_piece_re_pxay 1.svg"
              alt="Mulher negra mexendo em objetos abstratos." />
          </div>
          <p>
            Para completar seu perfil, <b>envie um cv</b> ou
            <b>preencha suas experiências profissionais</b>. Isso aumenta as suas
            chances de ser selecionado para a vaga.
          </p>
          <div class="popup-container--actions">
            <vs-button @click="handleReview">Completar meu Perfil</vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SimpleBasicInfo from "../resumes/simple/modules/SimpleBasicInfo";
import SimpleCurriculumn from "../resumes/simple/modules/SimpleCurriculumn";
import SimpleAddress from "../resumes/simple/modules/SimpleAddress";
import SimpleFormation from "../resumes/simple/modules/SimpleFormation";
import SimpleExperience from "../resumes/simple/modules/SimpleExperience";
import SimpleLanguages from "../resumes/simple/modules/SimpleLanguages";
import SimpleSkill from "../resumes/simple/modules/SimpleSkill";
import BackwardButton from "@/components/BackwardButton";
import ForwardButton from "@/components/ForwardButton";
import {
  fetchExistingApplication,
  takeQuickApplyPending,
} from "@/services/application";

export default {
  created() {
    window.scroll(0, 0);

    this.fetchForms();
    this.googleAnalytics();
  },
  components: {
    SimpleBasicInfo,
    SimpleCurriculumn,
    SimpleAddress,
    SimpleFormation,
    SimpleExperience,
    SimpleLanguages,
    SimpleSkill,
    BackwardButton,
    ForwardButton,
  },
  data: () => ({
    isForms: false,
    step_id: "",
    alert: false,
    reviewing: false,
  }),
  computed: {
    ...mapGetters("formation", ["emptyFormation"]),
    ...mapGetters("experience", ["experiencesIsEmpty", "unskilled"]),
    ...mapGetters("basicInfo", ["emptyCurriculumn"]),
    color() {
      return this.$store.state.company.company.base_hexcolor || "#1551b1";
    },
  },
  methods: {
    async fetchForms() {
      try {
        const { vacancy_id } = this.$router.history.current.params;

        if (vacancy_id) {
          const response = await this.$http.get(
            `/api/v1/questions/steps/vacancies/${vacancy_id}/exists`
          );

          this.isForms = response.data.data.step_id ? true : false;
          this.step_id = response.data.data.step_id;
        }
      } catch (error) {
        this.isForms = false;
      }
    },
    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/step/revision`)
        : this.$ga.page(`${company_label}/step/revision`);
    },

    handleBackward() {
      this.$store.dispatch("step/decrementCurrentStep");
      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params,
      });
    },

    async handleForward() {
      // Validação de informações profissionais (sempre executa, com ou sem formulários)
      const hasNoProfessionalInfo =
        this.emptyCurriculumn &&
        this.experiencesIsEmpty &&
        !this.unskilled &&
        this.emptyFormation;

      if (hasNoProfessionalInfo) {
        this.alert = true;
        return;
      }

      const { params } = this.$router.history.current;

      // Se há formulários personalizados, redireciona para eles
      if (this.isForms) {
        this.$router.push({
          name: "application-process",
          params: { ...params, step_id: this.step_id },
        });
        return;
      }

      // Veio do quick-apply de uma vaga: volta para la para confirmar. Os steps
      // nao criam candidatura, entao terminar em dashboard-vacancy deixaria o
      // candidato com o perfil pronto e sem candidatura nenhuma.
      if (takeQuickApplyPending(params.vacancy_id)) {
        this.$router.push({
          name: "quick-apply",
          params,
        });
        return;
      }

      // Login com Google em vaga encerrada nao cria candidatura e a API nao
      // sinaliza isso; sem candidatura, nao ha sucesso para mostrar.
      if (params.vacancy_id) {
        const { exists, hasFailed } = await fetchExistingApplication(params.vacancy_id);

        if (!exists && !hasFailed) {
          this.$vs.notify({
            color: "warning",
            title: "Vaga encerrada",
            text: "Esta vaga não está mais recebendo candidaturas.",
            time: 12000,
          });
          this.$router.push({
            name: "dashboard-vacancy",
            params: { company_label: params.company_label },
          });
          return;
        }
      }

      // Confirma candidatura diretamente
      this.$router.push({
        name: "dashboard-vacancy",
        params,
        query: {
          success: true,
        }
      });
    },

    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },

    handleReview() {
      this.alert = false;
      this.reviewing = true;

      const element = document.getElementsByClassName("revision__container");
      const top = element.offsetTop;
      window.scrollTo(0, top);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/views/steps/step.scss";

.revision__container {
  overflow-x: scroll;
}

.warning__container {
  padding: 8px;
  background-color: #ff9f43;
  border-radius: 2px;
  margin-bottom: 16px;

  color: #191919;
}

.warning__title {
  display: flex;
  align-items: center;
  font-weight: 600;
}

.warning__description {
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;

  button {
    padding: 0 !important;
    color: #0000ff !important;
    font-weight: 600 !important;
  }
}

.vs-popup--header {
  background: #fff;
}

.popup-container {
  width: 100%;

  h2 {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 19px;
    line-height: 23px;
    color: #172b4d;
  }

  p {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #172b4d;
  }

  &--image {
    margin: 20px 0;
    display: flex;
    text-align: center;
    justify-content: center;

    img {
      width: 281px;
      height: 288px;
    }
  }

  &--actions {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
